/**
 * OrbDocTutorialsIntermediateGuardsENDocEx1CheckoutView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsIntermediateGuardsENDocEx1Checkout
 */

import { useOrbDocTutorialsIntermediateGuardsENDocEx1CheckoutLogic } from '@/hooks/traits/useOrbDocTutorialsIntermediateGuardsENDocEx1CheckoutLogic';
import type { OrbDocTutorialsIntermediateGuardsENDocEx1CheckoutConfig } from '@/hooks/traits/useOrbDocTutorialsIntermediateGuardsENDocEx1CheckoutLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsIntermediateGuardsENOrder } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsIntermediateGuardsENDocEx1CheckoutViewProps {
  config?: Partial<OrbDocTutorialsIntermediateGuardsENDocEx1CheckoutConfig>;
}

export function OrbDocTutorialsIntermediateGuardsENDocEx1CheckoutView({ config: propsConfig }: OrbDocTutorialsIntermediateGuardsENDocEx1CheckoutViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsIntermediateGuardsENDocEx1CheckoutLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsIntermediateGuardsENOrder'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsIntermediateGuardsEN" trait="OrbDocTutorialsIntermediateGuardsENDocEx1Checkout">
      {slotWriter['main'] === 'INIT' ? (<Stack gap="sm"><Typography content="Unpaid" variant="h4" /><Button label="Pay 40" action="OrbDocTutorialsIntermediateGuardsEN.OrbDocTutorialsIntermediateGuardsENDocEx1Checkout.PAY" actionPayload={{amount: 40}} /></Stack>) : slotWriter['main'] === 'PAY' ? (<Stack gap="sm"><Typography content="Paid 40" variant="h4" /><Button label="Ship" action="OrbDocTutorialsIntermediateGuardsEN.OrbDocTutorialsIntermediateGuardsENDocEx1Checkout.SHIP" /></Stack>) : slotWriter['main'] === 'SHIP' ? (<Stack gap="sm"><Typography content="Shipped" variant="h4" /><Button label="New order" action="OrbDocTutorialsIntermediateGuardsEN.OrbDocTutorialsIntermediateGuardsENDocEx1Checkout.NEW_ORDER" /></Stack>) : slotWriter['main'] === 'NEW_ORDER' ? (<Stack gap="sm"><Typography content="Unpaid" variant="h4" /><Button label="Pay 40" action="OrbDocTutorialsIntermediateGuardsEN.OrbDocTutorialsIntermediateGuardsENDocEx1Checkout.PAY" actionPayload={{amount: 40}} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsIntermediateGuardsENDocEx1CheckoutView;
